/**
 * Normalize support-ticket API error payloads and map 403/429 to user-friendly strings.
 */

/**
 * @param {import('@reduxjs/toolkit/query').FetchBaseQueryError} error - RTK Query error
 * @returns {string} User-friendly message for create support ticket failures
 */
export function getSupportTicketCreateErrorMessage(error) {
  if (!error) return 'Failed to submit support ticket. Please try again.';
  const status = error?.status;
  const data = error?.data;
  const msg = typeof data?.message === 'string' ? data.message : '';

  if (status === 403) {
    return msg && msg.toLowerCase().includes('origin')
      ? 'This form can only be submitted from the application. Please use the Help & Support or login page.'
      : 'Access denied. Please use the Help & Support or login page to submit a ticket.';
  }
  if (status === 429) {
    return 'Too many requests. Please wait a moment and try again, or contact support directly.';
  }

  return msg || 'Failed to submit support ticket. Please try again.';
}
